module.exports = __webpack_public_path__ + "img/what-we-do.f45fc27c.webp";